<template>
    <section class="card card-info card-outline mb-4" role="region">
        <template v-if="station.enable_public_page">
            <div class="card-header">
                <h3 class="card-title">
                    Public Pages
                    <small class="badge badge-pill badge-success">Enabled</small>
                </h3>
            </div>
            <table class="table table-striped table-responsive-md mb-0">
                <colgroup>
                    <col style="width: 30%;">
                    <col style="width: 70%;">
                </colgroup>
                <tbody>
                <tr>
                    <td >Public Page</td>
                    <td>
                        <router-link :to="`/${station.short_name}`">{{station_info.public_page_uri}}</router-link>
                    </td>
                </tr>
                <tr>
                    <td >Player Embed Code</td>
                    <td class="form-field">
                        <textarea id="player_embed_url" v-model="publicPageEmbedCode" class="full-width form-control text-preformatted" spellcheck="false" style="height: 70px;"> </textarea>
                        <!-- <copy-to-clipboard-button target="#player_embed_url"></copy-to-clipboard-button> -->
                    </td>
                </tr>
                <tr v-if="station_info.supports_streamers && station.enable_streamers">
                    <td >Web DJ</td>
                    <td>
                        <router-link :to="`/${station.short_name}/dj`">{{station_info.public_web_dj_uri}}</router-link>

                    </td>
                </tr>

                <tr v-if="station.enable_on_demand">
                    <td>On-Demand Media</td>
                    <td>
                        <router-link :to="`/${station.short_name}/ondemand`">{{station_info.public_on_demand_uri}}</router-link>

                    </td>
                </tr>
                <tr v-if="station.enable_on_demand">
                    <td>On-Demand Embed Code</td>
                    <td>
                        <textarea id="ondemand_embed_url" class="full-width form-control text-preformatted" spellcheck="false" style="height: 70px;" v-model="publicOnDemandEmbedCode"></textarea>
                        <!-- <copy-to-clipboard-button target="#ondemand_embed_url"></copy-to-clipboard-button> -->
                    </td>
                </tr>

                <tr v-if="station_info.supports_requests && station.enable_station_requests">
                    <td>Request Embed Code</td>
                    <td class="form-field">
                        <textarea id="request_embed_url" class="full-width form-control text-preformatted" spellcheck="false" style="height: 70px;" v-model="publicRequestEmbedCode"></textarea>
                        <!-- <copy-to-clipboard-button target="#request_embed_url"></copy-to-clipboard-button> -->
                    </td>
                </tr>
                </tbody>
            </table>
           <div class="card-body">

            <div class="card-actions" v-if="userCanManageProfile">
                 <button :disabled="processing" @click.prevent="togglePublicPage" class="btn btn-outline-success btn-sm">
                     <i class="fas fa-times"></i>
                     {{processing? 'disabling...':'Disable'}}
                </button>
            </div>
            </div>
        </template>
        <template v-else>
            <div class="card-header">
                <h3 class="card-title">
                    Public Pages
                    <small class="badge badge-pill badge-danger btn-sm">Disabled</small>
                </h3>
            </div>
            <div class="card-body">
            <div class="card-actions" v-if="userCanManageProfile">
                <button :disabled="processing" @click.prevent="togglePublicPage" class="btn btn-outline-success btn-sm">
                    <i class="fas fa-check"></i>
                     {{processing? 'enabling...':'Enable'}}
                </button>

            </div>
            </div>
        </template>
    </section>
</template>

<script>
// import CopyToClipboardButton from '../components/CopyToClipboardButton';



export default {
    // components: { CopyToClipboardButton },

            // 'public_page_uri' => url($station->short_name) ,
            // 'public_web_dj_uri' => url($station->short_name) . '/dj' ,
            // 'public_on_demand_uri' => url($station->short_name) . '/ondemand' ,
            
    data(){

        return {
        userCanManageProfile: true,
        publicPageEmbedUri: '!#',
        publicOnDemandEmbedUri: '!#',
        publicRequestEmbedUri: '!#',
        togglePublicPageUri: 'admin/station/public',
        processing: false
    }

    },

    methods:{
        togglePublicPage(){
          
          this.processing = true
          axios.post(this.togglePublicPageUri).then( (res) => {
            this.$store.commit('updateStation', res.data)
             this.processing = false

        })
    }
    }
    ,
    computed: {
  
        publicPageEmbedCode () {
            return '<iframe src="' + this.publicPageEmbedUri + '" frameborder="0" allowtransparency="true" style="width: 100%; min-height: 150px; border: 0;"></iframe>';
        },
        publicOnDemandEmbedCode () {
            return '<iframe src="' + this.publicOnDemandEmbedUri + '" frameborder="0" allowtransparency="true" style="width: 100%; min-height: 400px; border: 0;"></iframe>';
        },
        publicRequestEmbedCode () {
            return '<iframe src="' + this.publicRequestEmbedUri + '" frameborder="0" allowtransparency="true" style="width: 100%; min-height: 850px; border: 0;"></iframe>';
        }
    }
};
</script>
